export default __webpack_public_path__ + "static/media/004-carpet.5ffb06f0.svg";